var _style, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 976 688.7",
    style: {
      enableBackground: "new 0 0 976 688.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.001064139,
    y1: 346.6393,
    x2: 976.029,
    y2: 346.6393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#BAC5F4",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B0C0F4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73,243.4c-0.4-1.2-0.8-2.4-1-3.6c-3.5-21.3-19.9-141,71.4-181.1c45-19.8,96-52.4,261,7.9 c194.7,71.2,322-49.5,352-49.5s98-43.5,178,41.5s20,187.9,20,187.9s-38,96.9-26,146.4s26,89,22,104.9c-4,15.8-6,122.7-72,146.4 c-66,23.7-44,19.8-198,11.9c-154-7.9-234,13.8-266,25.7s-80,7.9-166-49.5c-86-57.4-106-39.6-150-65.3s-155.8-168-62-271 C72.7,256.2,73.9,245.9,73,243.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 195.6,
    cy: 166.8,
    rx: 30.1,
    ry: 29.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 228.2,
    cy: 166.6,
    rx: 20.5,
    ry: 20.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 161.3,
    cy: 166.2,
    rx: 16.5,
    ry: 16.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 785.6,
    cy: 119.6,
    rx: 30.1,
    ry: 29.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 818.3,
    cy: 119.5,
    rx: 20.5,
    ry: 20.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 751.3,
    cy: 119,
    rx: 16.5,
    ry: 16.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 459.2,
    cy: 223.3,
    rx: 30.1,
    ry: 29.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 491.8,
    cy: 223.2,
    rx: 20.5,
    ry: 20.3
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 424.9,
    cy: 222.8,
    rx: 16.5,
    ry: 16.3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 705.4,
    cy: 218.2,
    r: 52.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 762.2,
    cy: 218,
    r: 35.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 645.8,
    cy: 217.3,
    r: 28.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 258.4,
    cy: 342.9,
    r: 52.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 315.2,
    cy: 342.7,
    r: 35.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 198.8,
    cy: 341.9,
    r: 28.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.8,
    cy: 505.6,
    r: 91
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 632.6,
    cy: 505.1,
    r: 61.9
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 430.1,
    cy: 503.9,
    r: 49.9
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.8,
    cy: 342.9,
    r: 21.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.1,
    cy: 342.8,
    r: 14.6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 545.3,
    cy: 342.5,
    r: 11.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2674dd0183f8d4aa9f25275800128b7a.svg";
export { ForwardRef as ReactComponent };